import React, { useEffect } from "react";
import Header from "./Header/Header";
import "./AnalyticsScreen.scss";
import BasicReports from "./BasicReports/BasicReports";
import { fetchBasicAnalyticsRequest } from "../../../redux/exam_analytics/analyticsSlice";
import { useDispatch, useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";

const AnalyticsScreen = () => {
  const dispatch = useDispatch();

  const paperId = useSelector((s) => s.examSlice.paperId);

  const { basicAnalytics, loading, error } = useSelector(
    (s) => s.analyticsSlice
  );

  // useEffect(() => {
  //   if (paperId) {
  //     dispatch(fetchBasicAnalyticsRequest());
  //   }
  // }, [paperId, dispatch]);
  const examSubmitted = useSelector(
  (s) => s.examSlice.examSubmitted
);

// useEffect(() => {
//   if (paperId && examSubmitted) {
//     dispatch(fetchBasicAnalyticsRequest());
//   }
// }, [paperId, examSubmitted, dispatch]);


  // const apiData = basicAnalytics?.data || null;
const apiData = basicAnalytics?.data;
const isScoreReady =
  apiData &&
  apiData.user_marks !== null &&
  apiData.total_marks !== null;


 
  if (loading?.basic) {
    return (
      <div className="analytics-loader">
        <ClipLoader color="#C61C26" size={55} />
      </div>
    );
  }

 
  if (error?.basic) {
    return (
      <div className="analytics-error">
        <p>Error: {error.basic}</p>
      </div>
    );
  }

  return (
    <div className="analytics-wrapper">
      {/* <Header paperName={apiData?.paper_name} />
      <BasicReports basicAnalytics={apiData} /> */}
      {/* <Header paperName={apiData?.paper_name} /> */}
      <Header
  paperName={apiData?.paper_name}
  backPath="/TestInstruction"
/>

{isScoreReady ? (
  <BasicReports basicAnalytics={apiData} />
) : (
  <div className="analytics-loader">
    <ClipLoader color="#C61C26" size={55} />
    <p>Preparing your scorecard...</p>
  </div>
)}

    </div>
  );
};

export default AnalyticsScreen;
